import { useTranslations } from 'next-intl';
import Link from 'next/link';

export interface SectionTitleProps {
  href: string;
  title: string;
}

export function SectionTitle(props: SectionTitleProps) {
  const t = useTranslations('homepage.section-title');
  return (
    <div className="flex justify-between items-end mb-4">
      <h1 className="text-white text-2xl font-bold font-quicksand">{props.title}</h1>
      <Link className="white font-bold text-sm" href={props.href}>
        {t('btn-show-all')}
      </Link>
    </div>
  );
}
